export default __webpack_public_path__ + "static/media/resume.929cc856.jpg";